module.exports = __webpack_public_path__ + "fonts/GreycliffCF-Heavy.86eeebb.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/GreyCliff/GreycliffCF-Heavy.ttf
// module id = 298
// module chunks = 245 246